import { VerificationNames } from "shared/types";

export const mergeHousingHistoryVerifications = <
  T extends { name: VerificationNames; title?: string }
>(
  verifications: T[],
  usePremiumVerificationIdWhenPaired = false
): T[] => {
  const premium = verifications.find(
    (v) => v.name === VerificationNames.PremiumHousingHistory
  );
  if (!premium) return verifications;

  const standard = verifications.find(
    (v) => v.name === VerificationNames.HousingHistory
  );

  const rest = verifications.filter(
    (v) =>
      v.name !== VerificationNames.PremiumHousingHistory &&
      v.name !== VerificationNames.HousingHistory
  );

  if (!usePremiumVerificationIdWhenPaired) {
    if (standard) return [...rest, standard];
    return [...rest];
  }

  const merged = {
    ...premium,
    name: VerificationNames.HousingHistory,
    title: standard?.title || premium.title
  } as T;

  return [...rest, merged];
};
